import { lazy, Suspense, useRef } from "react";
import { useInView } from "framer-motion";
import { useLang } from "../i18n/LangContext";
import { MaskLines, Reveal } from "../components/Reveal";
import { PrimaryCTA, GhostCTA } from "../components/Buttons";
import { BulbFallback } from "../components/BulbFallback";
import { hasWebGL, scrollToId } from "../lib/util";

const Signature = lazy(() => import("../components/Signature"));

export const Final = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const near = useInView(ref, { once: true, margin: "600px 0px" });
  return (
    <section ref={ref} id="final" data-core data-testid="final-section" className="relative z-[2] flex min-h-[110svh] flex-col items-center justify-end px-6 pb-28 pt-[52svh] text-center text-noor-emerald">
      {!hasWebGL() && <BulbFallback className="absolute left-1/2 top-[6%] h-[38vh] w-[28vh] -translate-x-1/2" />}
      {near && (
        <Suspense fallback={null}>
          <Signature className="relative mb-10 w-[min(80vw,340px)] xl:absolute xl:right-[3vw] xl:top-[15svh] xl:mb-0 xl:w-[min(27vw,440px)]" />
        </Suspense>
      )}
      <MaskLines as="h2" lines={t.final.lines} className="display-xl font-display text-noor-emerald" lineClassName="italic-accent text-noor-gold" testId="final-headline" />
      <Reveal as="p" delay={0.2} className="mt-8 max-w-2xl font-display text-xl text-noor-emerald/85 md:text-2xl">
        {t.final.desc}
      </Reveal>
      <Reveal delay={0.35} className="mt-12 flex flex-col items-center gap-4 sm:flex-row">
        <PrimaryCTA testId="final-primary-cta">{t.final.cta1}</PrimaryCTA>
        <GhostCTA tone="light" testId="final-secondary-cta" onClick={() => scrollToId("services")}>{t.final.cta2}</GhostCTA>
      </Reveal>
      <Reveal as="p" delay={0.5} className="mt-6 text-xs text-noor-emerald/75">{t.final.free}</Reveal>
    </section>
  );
};
